import Iconify from "@/components/iconify";
import { IconButton, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import { useState } from "react";
import CaktoApiConfirmationDialogDelete from "./CaktoApiConfirmationDialogDelete";

CaktoApiDeleteApyKey.propTypes = {
    apiKeyId: PropTypes.string.isRequired,
    currentPage: PropTypes.number.isRequired,
    resultsCount: PropTypes.number.isRequired,
    onPageDecrement: PropTypes.func.isRequired,
}

export default function CaktoApiDeleteApyKey({ apiKeyId, currentPage, resultsCount, onPageDecrement }) {

    const [open, setOpen] = useState(false);

    const handleOpenDialog = () => {
        setOpen(true);
    }

    const handleCloseDialog = () => {
        setOpen(false);
    }

    return (
        <>
            <IconButton onClick={handleOpenDialog} color="error">
                <Tooltip title="Excluir Chave API">
                    <Iconify icon="eva:trash-2-outline" />
                </Tooltip>

            </IconButton>

            <CaktoApiConfirmationDialogDelete
                open={open}
                handleCloseDialog={handleCloseDialog}
                apiKeyId={apiKeyId}
                currentPage={currentPage}
                resultsCount={resultsCount}
                onPageDecrement={onPageDecrement}
            />

        </>
    )
}